import { useSelector } from 'react-redux';
import { getNetworkStatus } from './index';

export const useNetworkStatus = () => useSelector(getNetworkStatus);
